// extracted by mini-css-extract-plugin
export var header = "styles_header__XWsyq";